import * as React from 'react';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';

const Seo = ({
  description = '',
  lang = 'pt-BR',
  meta = [],
  title,
  urlSlug = '',
  video,
  createdAt,
  updatedAt,
  image = `${process.env.GATSBY_APP_S3_CONTENT}/AprendiZap+Professores/aprendizaponboarding.webp`,
  bncc,
  subject,
  keywords,
}) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            siteUrl
          }
        }
      }
    `
  );
  const metaDescription = description || site.siteMetadata.description;
  const defaultTitle = site.siteMetadata?.title;
  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      defaultTitle={defaultTitle}
      titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          name: `image`,
          content: image,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:locale`,
          content: lang,
        },
        {
          name: 'og:url',
          content: `${site?.siteMetadata?.siteUrl}/${urlSlug}/`,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:image`,
          content: image,
        },
        {
          name: `twitter:card`,
          content: `summary_large_image`,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          name: `twitter:image`,
          content: image,
        },
        {
          name: `google-site-verification`,
          content: 'lehXG08C7PGMRAP1D4yPOom-JfbFbgcJSo2LN2a-D2U',
        },
      ].concat(meta)}
    >
      {video && (
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': ['VideoObject', 'LearningResource'],
            name: title,
            description: description,
            learningResourceType: 'Concept Overview',
            educationalLevel: 'beginner',
            assesses: bncc?.description,
            about: {
              '@type': 'Thing',
              name: keywords?.join('; '),
            },
            educationalAlignment: [
              {
                '@type': 'AlignmentObject',
                alignmentType: 'educationalSubject',
                targetName: subject,
              },
              {
                '@type': 'AlignmentObject',
                alignmentType: 'educationalSubject',
                targetName: bncc?.code,
              },
            ],
            contentUrl: `youtu.be/${video}`,
            thumbnailUrl: [`https://i.ytimg.com/vi/${video}/hqdefault.jpg`],
            uploadDate: createdAt,
          })}
        </script>
      )}
      {description && bncc && keywords && (
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': ['Article', 'LearningResource'],
            headline: title,
            image: [image],
            description: description,
            articleSection: 'Educação',
            learningResourceType: 'Concept Overview',
            educationalLevel: 'beginner',
            assesses: bncc.description,
            about: {
              '@type': 'Thing',
              name: keywords?.join('; '),
            },
            educationalAlignment: [
              {
                '@type': 'AlignmentObject',
                alignmentType: 'educationalSubject',
                targetName: subject,
              },
              {
                '@type': 'AlignmentObject',
                alignmentType: 'educationalSubject',
                targetName: bncc.code,
              },
            ],
            datePublished: createdAt,
            dateModified: updatedAt,
            author: [
              {
                '@type': 'Organization',
                name: 'Fundação 1Bi',
                url: 'https://www.fundacao1bi.com.br/',
              },
            ],
          })}
        </script>
      )}
    </Helmet>
  );
};

export default Seo;
